import React, { useEffect, useRef, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Certifications from './components/Certifications';
import Footer from './components/footer';

const App = () => {
  const cursorDot = useRef(null);
  const cursorRing = useRef(null);
  const [activeSection, setActiveSection] = useState('home');

  // Custom cursor
  useEffect(() => {
    const moveCursor = (e) => {
      if (cursorDot.current) {
        cursorDot.current.style.left = e.clientX + 'px';
        cursorDot.current.style.top = e.clientY + 'px';
      }
      if (cursorRing.current) {
        cursorRing.current.style.left = e.clientX + 'px';
        cursorRing.current.style.top = e.clientY + 'px';
      }
    };
    window.addEventListener('mousemove', moveCursor);
    return () => window.removeEventListener('mousemove', moveCursor);
  }, []);

  // Active section tracker
  useEffect(() => {
    const sections = ['home', 'about', 'skills', 'projects', 'contact'];
    const observers = sections.map((id) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const observer = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActiveSection(id); },
        { threshold: 0.4 }
      );
      observer.observe(el);
      return observer;
    });
    return () => observers.forEach((obs) => obs && obs.disconnect());
  }, []);

  return (
    <div className="bg-[#0a0f1e] text-slate-200 min-h-screen overflow-x-hidden">
      <div ref={cursorDot} className="cursor-dot hidden md:block" />
      <div ref={cursorRing} className="cursor-ring hidden md:block" />
      <Header activeSection={activeSection} />
      <main>
        <section id="home"><Hero /></section>
        <section id="about"><About /></section>
        <section id="skills"><Skills /></section>
        <section id="projects"><Projects /></section>
        <section id="certifications"><Certifications /></section>
        <section id="contact"><Contact /></section>
      </main>
      <Footer />
    </div>
  );
};

export default App;
